import React from "react";
import "../css/Gallery.css";

const Gallery = () => {
  const images = [
    "https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg",
    "https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg",
    "https://images.pexels.com/photos/2247179/pexels-photo-2247179.jpeg",
    "https://images.pexels.com/photos/703016/pexels-photo-703016.jpeg",
    "https://images.pexels.com/photos/949126/pexels-photo-949126.jpeg",
    "https://images.pexels.com/photos/1480520/pexels-photo-1480520.jpeg",
    "https://images.pexels.com/photos/2294403/pexels-photo-2294403.jpeg",
    "https://images.pexels.com/photos/116077/pexels-photo-116077.jpeg",
    "https://images.pexels.com/photos/1144864/pexels-photo-1144864.jpeg",
    "https://images.pexels.com/photos/4761352/pexels-photo-4761352.jpeg",
    "https://images.pexels.com/photos/2261485/pexels-photo-2261485.jpeg",
    "https://images.pexels.com/photos/140955/pexels-photo-140955.jpeg",
  ];

  return (
    <div className="gallery-page">

      {/* HERO HEADER */}
      <section className="gal-hero">
        <h1>ATHLETIC<br/>ENERGY</h1>
        <p>A visual archive of movement, focus & raw power.</p>
      </section>


      {/* OFFSET GRID GALLERY */}
      <section className="gal-grid">
        {images.map((img, index) => (
          <div
            key={index}
            className={`gal-item ${index % 5 === 0 ? "tall" : ""} ${
              index % 7 === 0 ? "wide" : ""
            }`}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}
      </section>


      {/* PANEL QUOTE */}
      <section className="gal-panel">
        <h2>STRONG FRAMES. STRONGER STORIES.</h2>
        <p>Every athlete has a moment where everything aligns—skill, precision, mindset.</p>
      </section>

    </div>
  );
};

export default Gallery;
